import React from "react";
import Navbar from "./Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faRotateRight, faShop, faTruck } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import ActiveRidePage from "./ActiveRidePage";
import { useLocation } from "react-router-dom";
import { useNotification } from '../context/NotificationContext';
import { decryptData } from '../utils/storageCrypto';

const Rides = () => {
  const [mockRides, setMockRides] = useState([]);
  const URL = process.env.REACT_APP_FORE_BRICKBUCKET;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mobile_number = queryParams.get("mobile");
  const { state } = useLocation();
  const isBrickbucket = state?.isBrickbucket || false; // Default to false if not present
  const { notifications, setNotifications } = useNotification();
  console.log("notifications from context in action center:", notifications);

  const [activeRide, setActiveRide] = useState(null);
  const [rideStarted, setRideStarted] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [rideDistances, setRideDistances] = useState({});
  const [loadingDistance, setLoadingDistance] = useState(false);

  useEffect(() => {
    if (mobile_number) {
      loadActiveRide(mobile_number);
    }
    // Request live location on component mount
    requestLiveLocation();
  }, [mobile_number]);

  // Haversine formula to calculate distance between two coordinates (lat, lon)
  const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (x) => (x * Math.PI) / 180;
    const R = 6371; // Earth's radius in km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return parseFloat((R * c).toFixed(1));
  };

  // Request live location from browser geolocation API
  const requestLiveLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          console.log('Current location:', position.coords.latitude, position.coords.longitude);
        },
        (error) => {
          console.warn('Geolocation error:', error.message);
          // Fallback: Use mock location for testing on desktop
          // You can replace these with your actual test coordinates
          const mockLocation = {
            latitude: 16.5,
            longitude: 80.65,
          };
          setCurrentLocation(mockLocation);
          console.log('Using mock location for testing:', mockLocation);
        },
        {
          enableHighAccuracy: false,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      // Fallback if geolocation not supported
      const mockLocation = {
        latitude: 16.5,
        longitude: 80.65,
      };
      setCurrentLocation(mockLocation);
      console.log('Geolocation not supported. Using mock location:', mockLocation);
    }
  };

  // Calculate pickup distance for a ride
  const calculatePickupDistance = (ride) => {
    console.log("calculating pick up distance:",ride)
    if (!currentLocation || !ride.route.pickups.length === 0 || !ride.route.dropoffs.length === 0) {
      return 'N/A';
    }
    // Find first PICKUP stop
    const firstPickup = ride.route.pickups.find(stop => Number(stop.stopSequence) === 1);
    console.log(firstPickup)
    if (!firstPickup || (!firstPickup.latitude && !firstPickup.longitude)) {
      return 'N/A';
    }
    console.log(currentLocation)
    const distance = haversineDistance(
      currentLocation.latitude,
      currentLocation.longitude,
      firstPickup.latitude,
      firstPickup.longitude
    );
    return `${distance} km`;
  };

  const loadActiveRide = async (mobile) => {
    const activeRide = await fetchActiveRide(mobile);
    if (activeRide) {
      setActiveRide(activeRide);
    } else {
      setActiveRide(null);
      if (isBrickbucket) {
        fetchRides(mobile);
      }
    }
  };

  const fetchActiveRide = async (mobile) => {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    try {
      if (!mobile) {
        throw new Error("Mobile number is required");
      }

      const response = await fetch(
        `${URL}delivery-partner/get-active-ride?mobile=${mobile}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'x-token':token
          }
        }
      );

      const result = await response.json();
      console.log("Fetch active ride response:", result);
      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch active ride");
      }

      return result.data; // Active ride data
    } catch (error) {
      console.error("Error fetching active ride:", error.message);
      return null;
    }
  };

  const fetchRides = async (mobile) => {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    console.log("Fetching rides...");
    try {
      if (!mobile) {
        throw new Error("Mobile number is required");
      }
      const response = await fetch(`${URL}delivery-partner/get-rides?mobile=${mobile}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'x-token':token
        },
      });
      const data = await response.json();
      console.log("Rides data:", data);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      setMockRides(data.data);
    } catch (error) {
      console.error("Failed to load rides", error);
    }
  };

  const acceptRide = async (shipmentId) => {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    try {
      if (!mobile_number) {
        throw new Error("Mobile number is required to accept ride");
      }

      const response = await fetch(`${URL}delivery-partner/accept-ride`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-token':token
        },
        body: JSON.stringify({ shipmentId, mobile: mobile_number })
      });
      console.log("Accept ride response status:", response);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to accept ride");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Accept ride failed:", error.message);
      throw error;
    }
  };

  const handleAcceptRide = async (shipmentId) => {
    try {
      await acceptRide(shipmentId);
      alert("Ride accepted successfully");
      await loadActiveRide(mobile_number);
    } catch (error) {
      alert(error.message);
    }
  };

  const handleRefreshDistance = (rideId) => {
    setLoadingDistance(true);
    requestLiveLocation();
    // Simulate distance recalculation after location update
    setTimeout(() => {
      setLoadingDistance(false);
    }, 500);
  };

  const handleBecomeBrickbucket = () => {
    // Add logic to handle becoming a Brickbucket partner, e.g., redirect or API call
    console.log("Redirecting to become Brickbucket partner");
    // Example: window.location.href = "/become-brickbucket";
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />

      <div className="px-4 py-6">
        <div className="max-w-md mx-auto space-y-5">
          {activeRide ? (
            <ActiveRidePage
              activeRide={activeRide}
              GetRideDetails={loadActiveRide}
              mobile={mobile_number}
              onGetNewRides={loadActiveRide}
            />
          ) : isBrickbucket ? (
            mockRides.length > 0 ? (
              mockRides.map((ride) => (
                <div
                  key={ride.id}
                  className="bg-white rounded-2xl border border-gray-200 shadow-sm"
                >
                  <div className="p-4 space-y-4">
                    {/* TOP PRIORITY: Pickup Distance */}
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-gray-500">
                          Distance to first pickup
                        </p>
                        <button
                          onClick={() => handleRefreshDistance(ride._id)}
                          className="flex items-center gap-2 mt-1 text-sm font-bold text-blue-600 hover:text-blue-700 underline underline-offset-2 disabled:opacity-50"
                          title="Tap to refresh distance from your location"
                          disabled={loadingDistance}
                        >
                          {loadingDistance ? 'Updating...' : calculatePickupDistance(ride)}
                          <FontAwesomeIcon
                            icon={faRotateRight}
                            className={`text-xs ${loadingDistance ? 'animate-spin' : ''}`}
                          />
                        </button>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-extrabold text-green-600">
                          {ride.earnings}
                        </p>
                      </div>
                    </div>

                    {/* Route Summary */}
                    <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                      {/* Header */}
                      <div className="flex items-center justify-between">
                        <p className="text-xs font-semibold text-gray-500 tracking-wide">
                          ROUTE
                        </p>
                        <p className="text-xs font-semibold text-gray-600">
                          Total: {ride.route.totalDistance || 'N/A'}
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        {/* PICKUPS */}
                        <div>
                          <div className="flex items-center gap-2 mb-3">
                            <FontAwesomeIcon
                              icon={faShop}
                              className="text-gray-500 text-sm"
                            />
                            <p className="text-xs font-semibold text-gray-700 uppercase">
                              Pickups ({ride.route.pickups.length})
                            </p>
                          </div>
                          <ul className="space-y-3">
                           {ride.route.pickups.map((p, idx) => (
                          <li key={idx} className="flex items-start gap-2">
                            <span className="mt-1 w-2 h-2 rounded-full bg-blue-600 shrink-0"></span>
                            <div>
                              <p className="text-sm font-semibold text-gray-900 leading-tight line-clamp-3 overflow-hidden">
                                {p.name}
                              </p>
                              <p className="text-xs text-gray-500">
                                {p.area}
                              </p>
                            </div>
                          </li>
                        ))}
                          </ul>
                        </div>

                        {/* DROP-OFFS */}
                        <div>
                          <div className="flex items-center gap-2 mb-3">
                            <FontAwesomeIcon
                              icon={faTruck}
                              className="text-gray-500 text-sm"
                            />
                            <p className="text-xs font-semibold text-gray-700 uppercase">
                              Drop-offs ({ride.route.dropoffs.length})
                            </p>
                          </div>
                          <ul className="space-y-3">
                            {ride.route.dropoffs.map((d, idx) => (
                            <li key={idx} className="flex items-start gap-2">
                              <span className="mt-1 w-2 h-2 rounded-full bg-blue-600 shrink-0"></span>
                              <div>
                                <p className="text-sm font-semibold text-gray-900 leading-tight line-clamp-3 overflow-hidden">
                                  {d.name}
                                </p>
                                <p className="text-xs text-gray-500">
                                  {d.area}
                                </p>
                              </div>
                            </li>
                          ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Secondary Metrics */}
                    <div className="grid grid-cols-2 gap-2">
                      {/* Items Count */}
                      <Metric label="Items" value={ride.items} />

                      {/* Item Preview */}
                      <div className="bg-gray-100 rounded-xl py-2 flex items-center justify-center">
                        {ride.imageUrl ? (
                          <img
                            src={ride.imageUrl}
                            alt="Item preview"
                            className="h-10 w-10 object-cover rounded-md"
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faImage}
                            className="text-gray-400 text-xl"
                          />
                        )}
                      </div>
                    </div>

                    {/* CTA */}
                    <button
                      className="w-full py-3 rounded-xl bg-red-600 hover:bg-red-700 text-white font-bold"
                      onClick={(e) => handleAcceptRide(ride._id)}
                    >
                      Accept Ride
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 text-center">
                <p className="text-lg font-semibold text-gray-700">No rides available now</p>
                <p className="text-sm text-gray-500 mt-2">Please wait for new rides to be assigned.</p>
              </div>
            )
          ) : (
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 text-center space-y-4">
              <p className="text-lg font-semibold text-gray-700">Become a Brickbucket Delivery Partner</p>
              <p className="text-sm text-gray-500">As a supplier delivery partner, you don't have access to rides. Would you like to become a Brickbucket delivery partner to start accepting rides?</p>
              <button
                className="w-full py-3 rounded-xl bg-red-600 hover:bg-red-700 text-white font-bold"
                onClick={handleBecomeBrickbucket}
              >
                Become Brickbucket Partner
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Metric = ({ label, value }) => (
  <div className="bg-gray-100 rounded-xl py-2 text-center">
    <p className="text-[11px] text-gray-500">{label}</p>
    <p className="text-sm font-semibold text-gray-900">{value}</p>
  </div>
);

export default Rides;